// routes/_embedded.embedded.event.$eventRoute.$.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.event.$eventRoute.$')

export const handle = {
  name: 'embedded-event-page',
  hideMembershipBanner: true,
  track: ({ params }: { params: { eventRoute?: string } }) => ({
    scene: 'event',
    section: params.eventRoute,
  }),
}

export function loader() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
